export { default, USER_PROFILE_QUERY } from "./UserProfile";
